import ajax from "./ajax";

export function bookmarkJob(data) {
  return ajax(`/MarkJob`, { method: "POST", data });
}

export function getBookmarkJobs(params = '') {
  return ajax(`/MarkJob?sort=-id${params}`);
}

export function removeBookmarkJob(id) {
  return ajax(`/MarkJob/${id}`, { method: "DELETE" });
}
